import React, {Component} from "react";
import {stateFromHTML} from "draft-js-import-html";
import {convertToRaw, EditorState} from "draft-js";
import draftToHtml from "draftjs-to-html";
import {Editor} from "react-draft-wysiwyg";
class LeadershipForm extends Component{
    constructor(props) {
        super(props);
        const contentBlocks = stateFromHTML(this.props.data.description);
        this.state = {
            editorState: EditorState.createWithContent(contentBlocks  !=="" ?  contentBlocks : ''),
        };
    }

    onEditorStateChange  = editorState => {
        this.setState({
            editorState,
        });
        this.props.data.description = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    };
    render() {
        const { editorState } = this.state;
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="card-body"  style={{textAlign: 'left'}}>
                    <div className="scroll-y me-n7 pe-7" id="kt_modal_new_address_scroll text-left" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_new_address_header" data-kt-scroll-wrappers="#kt_modal_new_address_scroll" data-kt-scroll-offset="300px">
                        <div className="row mb-5">
                            <div className="col-md-6 fv-row">
                                <label className="required fs-5 fw-bold mb-2">Title</label>
                                <input
                                    type="text"
                                    className="form-control form-control-solid  mb-5"
                                    name="title"
                                    id="title"
                                    onChange={this.props.onEdit}
                                    value={this.props.data.title}
                                    placeholder="title"
                                />
                            </div>
                            <div className="col-md-6 fv-row">
                                <label className="required fs-5 fw-bold mb-2">Full Name</label>
                                <input
                                    type="text"
                                    className="form-control form-control-solid  mb-5"
                                    name="fullname"
                                    id="fullname"
                                    onChange={this.props.onEdit}
                                    value={this.props.data.fullname}
                                    placeholder="Full Name"
                                />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6 fv-row">
                                <label className="required fs-5 fw-bold mb-2">Designation </label>
                                <input
                                    type="text"
                                    className="form-control form-control-solid  mb-5"
                                    name="designation"
                                    id="designation"
                                    onChange={this.props.onEdit}
                                    value={this.props.data.designation}
                                    placeholder="designation"
                                />
                            </div>
                             <div className="col-md-6 fv-row">
                                    <label className="required fs-5 fw-bold mb-2">Position</label>
                                    <select
                                        className="form-control form-control-solid"
                                        name="position"
                                        id="position"
                                        onChange={this.props.onEdit}
                                        value={this.props.data.position}
                                    >
                                        <option value="">Select position</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                        <option value="13">13</option>
                                        <option value="14">14</option>
                                        <option value="15">15</option>
                                        <option value="16">16</option>
                                        <option value="17">17</option>
                                        <option value="18">18</option>
                                        <option value="19">19</option>
                                        <option value="20">20</option>
                                    </select>
                            </div>

                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6 fv-row">
                                <label className="required fs-5 fw-bold mb-2">Image</label>
                                <input
                                    type="file"
                                    className="form-control form-control-solid  mb-5"
                                    name="photo"
                                    id="photo"
                                    onChange={this.props.onImageChange}
                                    accept="image/*"
                                />
                            </div>

                            <div className="col-md-6 fv-row">
                                <label className="required fs-5 fw-bold mb-2">Status</label>
                                <select
                                    className="form-control form-control-solid"
                                    name="status"
                                    id="status"
                                    onChange={this.props.onEdit}
                                    value={this.props.data.status}
                                >
                                    <option value="">Select Status</option>
                                    <option value="1">Active</option>
                                    <option value="0">Draft</option>
                                </select>
                            </div>


                        </div>

                        <div className="row mb-5">
                            <div className="col-md-12 fv-row">
                                <label className=" fs-5 fw-bold mb-2">Description</label>
                                <Editor
                                    className="form-control form-control-solid"
                                    rows={4}
                                    name="description"
                                    id="description"
                                    onEditorStateChange={this.onEditorStateChange}
                                    wrapperClassName="form-control form-control-solid"
                                    editorClassName="form-control form-control-solid"
                                    editorState={editorState}
                                />
                                {/*<blockquote dangerouslySetInnerHTML={{__html: `${this.state.alumniSlider.Description} <br/> - <b> {this.state.alumniSlider.StudentName}</b>`}} style={{ fontSize: 13 }}/>*/}
                            </div>
                        </div>

                        <button type="submit" id="kt_modal_new_address_submit" data-kt-indicator={this.props.isLoading} className="btn btn-primary w-25 offset-sm-4 mb-9 mt-9">
                            <span className="indicator-label">Submit</span>
                            <span className="indicator-progress">Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

export default LeadershipForm;